import { useEffect, useRef } from 'react';

const TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes
const EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];

export function useInactivityTimer() {
  const timerRef = useRef(null);

  useEffect(() => {
    const isLoggedIn = () => !!localStorage.getItem('token');

    const logout = () => {
      ['token', 'user', 'school'].forEach(k => localStorage.removeItem(k));
      window.location.replace('/');
    };

    const reset = () => {
      if (!isLoggedIn()) return;
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(logout, TIMEOUT_MS);
    };

    if (!isLoggedIn()) return;

    // Start the timer and attach listeners
    reset();
    EVENTS.forEach(evt => window.addEventListener(evt, reset, { passive: true }));

    return () => {
      clearTimeout(timerRef.current);
      EVENTS.forEach(evt => window.removeEventListener(evt, reset));
    };
  }, []);
}
